<template>
    <div>
        <div class="content ht-100v pd-0">
            <div class="content-body pd-10">
                <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                                <li class="breadcrumb-item">
                                    <router-link to="/payments/">Payments</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">Funds Transfer - Bulk</li>
                            </ol>
                        </nav>
                        <h4 class="mg-b-0 tx-spacing--1">Funds Transfer Multiple</h4>
                    </div>
                    <div class="d-none d-md-block">
<!--dd-->

                        <button v-if="this.alltrans.length > 0 && ft.batchDetails.batchid === 0"
                                class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" @click="upload">
                            <template v-if="ft.ftLoading">
                                <span class="spinner-border spinner-border-sm text-secondary tx-light" role="status">
                                </span>
                            </template>
                            <filter-icon v-else class="wd-10 mg-r-5"></filter-icon>
                            Validate
                        </button>

                        <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" @click="downloadSample('bankcodes')">
                            <DownloadCloudIcon class="mg-r-5"/>
                            Download Bank Codes
                        </button>
                        <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" @click="downloadSample('template')">
                            <DownloadCloudIcon class="mg-r-5"/>
                            Download Template
                        </button>
                        <b-button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-b-modal="'account-modal'">
                            <file-icon class="wd-10 mg-r-5"></file-icon>
                            File Upload
                        </b-button>
                        <button v-if="ft.authloading" disabled class="btn btn-sm  btn-white mg-l-5">
                            <span class="spinner-border spinner-border-sm mg-r-5 tx-light" role="status"
                                  aria-hidden="true"></span>
                            Loading...
                        </button>
                        <button v-else-if="this.screen === 'validate'"
                                class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" @click="push">
                            <ArchiveIcon size="3x" class="wd-10 mg-r-5"/>
                            Push To Queue
                        </button>

                    </div>
                </div>
                <native-card :carditems="ft.cards"></native-card>
                <hr>
                <funds-transfer-table
                        :items="ft.transactions"
                        :is-busy="false"
                        :accounts="accountoption"></funds-transfer-table>
                <revenue-table v-if="vis === true"></revenue-table>

            </div>
        </div><!-- content -->


        <b-modal id="account-modal" :hide-header="true" :hide-footer="true" :centered="true" ref="account-modal">
            <div class="modal-body">
                <a href="#" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close"
                   @click="hide()">
                    <span aria-hidden="true">&times;</span>
                </a>

                <div>
                    <h4>Upload File For Processing</h4>
                    <p class="tx-color-03">Upload file for processing</p>
                    <b-form @submit.prevent="onSubmit" enctype="multipart/form-data">
                        <b-form-group>
                            <div class="dropbox">
                                <input multiple type="file" class="input-file" id="files" :name="file.uploadFieldName"
                                       :disabled="isSaving"
                                       @change="uploadFile" ref="file">
                                <p v-if="isInitial">
                                    Drag your file(s) here to begin<br> or click to browse
                                </p>
                                <p v-if="isSaving">
                                    Uploading files...
                                </p>

                            </div>
                        </b-form-group>
                        <b-button type="submit" class="btn btn-secondary btn-block btn-sm">Submit</b-button>
                    </b-form>
                </div>
            </div><!-- modal-body -->
        </b-modal>


    </div>


</template>

<script>
    import FundsTransferTable from "../../components/table/FundsTransferTable";
    import {mapState} from 'vuex'
    import {DownloadCloudIcon, FileIcon, FilterIcon, ArchiveIcon} from "vue-feather-icons";
    import NativeCard from "../../components/card/NativeCard";
    import RevenueTable from "../../components/card/RevenueTable";
    import axios from "axios";

    const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
    export default {
        name: 'FundsTransferMultiple',
        components: {
            ArchiveIcon,
            RevenueTable,
            NativeCard,
            FundsTransferTable,
            FileIcon,
            DownloadCloudIcon,
            FilterIcon,
        },
        data() {
            return {
                url: "https://businessbanking.rubies.ng/sample/bulkupload.csv",
                bankurl: "https://cors-anywhere.herokuapp.com/https://cbank.rubies.ng/sample/bankcode.csv",
                model: {
                    accountnumber: '',
                    accountname: '',
                    source: 'FILE',
                    filecontents: '',
                    customerid: '',
                    filename: '',
                },
                screen: 'upload',
                vis: false,
                file: {
                    accountnumber: '',
                    file: '',
                    amount: '',
                    status: false,
                    bank: {},
                    narration: '',
                    uploadedFiles: [],
                    uploadError: null,
                    currentStatus: null,
                    uploadFieldName: 'photos',
                },
                banks: [
                    {text: 'Select One', value: null},
                    {text: 'Zenith Bank', value: {bank: 'Zenith Bank', bankcode: '00001'}},
                    {text: 'Rubies Bank', value: {bank: 'Rubies Bank', bankcode: '00002'}}
                ],
                items: [],
                accoption: []
            }


        },
        methods: {
            onSubmit() {
                this.file.currentStatus = STATUS_SAVING;
            },
            uploadFile(event) {
                this.handleUpload(event)
            },
            reset() {
                this.$store.commit("account/updateCurrentAccount", []);
                this.file.currentStatus = STATUS_INITIAL;
                this.file.uploadedFiles = [];
                this.file.uploadError = null;
            },
            async handleUpload(event) {
                const file = event.target.files[0];
                const reader = new FileReader();
                try {
                    reader.onload = async e => {
                        let response = await this.readUploadedFileAsText(e.target.result, file);
                        this.$store.commit('ft/UPDATE_TRANSACTIONS', response);
                        this.$store.commit("ft/updateTranSummary", response);
                        this.vis = true;
                        this.$refs['account-modal'].hide();

                    };
                    reader.readAsText(file);
                } catch (e) {
                    console.warn(e.message)
                }
            },
            readUploadedFileAsText: async function (csv, _file) {
                this.model.filecontents = btoa(csv);
                this.model.filename = _file.name;
                if (_file.type !== 'text/csv') {
                    await this.$swal({
                        title: 'Error',
                        text: 'Invalid header format',
                        icon: 'error',
                        showCancelButton: false,
                        confirmButtonText: 'Ok'
                    });
                }
                const lines = csv.split('\n');
                const headers = lines[0].split(',');
                const myheaders = ["creditbankcode", "creditbankname", "creditaccount", "craccountname", "amount", "Narration\r"];
                const csv2json = (str, delimiter = ',') => {
                    const titles = str.slice(0, str.indexOf('\n')).split(delimiter);
                    const rows = str.trim().slice(str.indexOf('\n') + 1).split('\n');
                    return rows.map(row => {
                        const values = row.split(delimiter);
                        return titles.reduce((object, curr, i) => (object[curr] = values[i], object), {})
                    });
                };
                if (JSON.stringify(headers) !== JSON.stringify(myheaders)) {
                    this.$swal({
                        title: 'Error',
                        text: 'Invalid header format',
                        icon: 'error',
                        showCancelButton: false,
                        confirmButtonText: 'Ok'
                    })
                } else {
                    return csv2json(csv, ",");
                }
            },
            async upload() {
                console.log(JSON.stringify(this.currentacc) === '{}');
                if (JSON.stringify(this.currentacc) === '{}') {
                    this.$swal({
                        title: 'Error',
                        text: 'Please Select Debit Account',
                        icon: 'error',
                        showCancelButton: true,
                        confirmButtonText: 'Ok'
                    });
                } else {
                    this.model.accountnumber = this.currentacc.accountnumber;
                    this.model.customerid = this.authobj.customerid;
                    this.model.accountname = this.currentacc.accountname;
                    this.model.username = this.authobj.username;
                    const response = await this.$store.dispatch("ft/uploadFt", this.model, {root: false});
                    if (response.responsecode === '00') {
                        //this.$store.commit('ft/UPDATE_TRANSACTIONS', response.trasactions);
                        this.tsq()
                    } else {
                        this.$swal({
                            title: 'Error',
                            text: response.responsemessage,
                            icon: 'warning',
                            showCancelButton: false,
                            confirmButtonText: 'Ok'
                        })
                    }
                }

            },
            async tsq() {
                let cond = true;
                while (cond) {
                    let resp = await this.$store.dispatch("ft/readBatchStatus",
                        {batchid: this.ft.batchNumber}, {root: false});
                    const res = await this.$store.dispatch("ft/readBatchTransactions",
                        {batchref: resp.batchid}, {root: false});
                    this.$store.commit('ft/UPDATE_TRANSACTIONS', res.trasactions);
                    if (resp.status === 'completed') {
                        let trans = await this.$store.dispatch("ft/readBatchTransactions", {
                            batchref: resp.batchid
                        }, {root: false});
                        this.$store.commit('ft/UPDATE_TRANSACTIONS', trans.trasactions);
                        this.screen = 'validate';
                        cond = false;
                        this.$swal({
                            title: 'Success',
                            text: 'Name Enquiry Validation Complete',
                            icon: 'success',
                            showCancelButton: false,
                            confirmButtonText: 'Ok'
                        })
                    }
                }

            },
            forceFileDownload: function(response, file){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                const fl  = file === 'bankcodes' ? 'bankcodes.csv' : 'bulkuploadtemplate.csv';
                link.setAttribute('download', fl); //or any other extension
                document.body.appendChild(link);
                link.click()
            },
            downloadSample: function(file){
                axios({
                    method: 'get',
                    url: file === 'bankcodes' ? this.bankurl : this.url,
                    responseType: 'arraybuffer'
                }).then(response => this.forceFileDownload(response, file)).catch(err => console.log(err))
            },


        push: async function () {
                let model = {
                    userid: this.authobj.username,
                    batchid: this.ft.batchDetails.batchid,
                };
                let result = await this.$store.dispatch("ft/queueBatch", model, {root: false});
                this.$swal({
                    title: result.responsecode === '00' ? 'Success' : 'Warning',
                    text: result.responsemessage,
                    icon: result.responsecode === '00' ? 'success' : 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'Ok'
                });
                this.screen = '';
                const payload = {customerid: this.authobj.customerid, status: 'completed'};
                await this.$store.dispatch("ft/readAllBatches", payload, {root: false});
                this.$store.commit('ft/UPDATE_TRANSACTIONS', []);
            },
            hide() {
                this.$refs['account-modal'].hide()
            },

        },
        computed: {
            accountoption() {
                return this.$store.state.account.accountoption
            },
            alltrans() {
                return this.$store.state.ft.transactions
            },
            currentacc() {
                return this.$store.state.account.currentAccount
            },
            getaccounts: function () {
                return this.account.allAccountsOriginal
            },
            authobj: function () {
                return this.$store.state.auth.response
            },
            acc: function () {
                return this.$store.state.account.allAccounts
            },
            isInitial() {
                return this.file.currentStatus === STATUS_INITIAL;
            },
            isSaving() {
                return this.file.currentStatus === STATUS_SAVING;
            },
            isSuccess() {
                return this.file.currentStatus === STATUS_SUCCESS;
            },
            isFailed() {
                return this.file.currentStatus === STATUS_FAILED;
            },
            ...mapState(['ft', 'customer', 'account']),
        },
        mounted() {
            this.reset();
        },
        created() {
        }


    }


</script>

<style scoped>

    .dropbox {
        outline: 2px dashed grey; /* the dash box */
        outline-offset: -10px;
        background: lightcyan;
        color: dimgray;
        padding: 10px 10px;
        min-height: 200px; /* minimum height */
        position: relative;
        cursor: pointer;
    }

    .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        height: 100px;
        position: absolute;
        cursor: pointer;
    }

    .dropbox:hover {
        background: lightblue; /* when mouse over to the drop zone, change color */
    }

    .dropbox p {
        font-size: 1.2em;
        text-align: center;
        padding: 50px 0;
    }

</style>
